import {
    useNFTCollectionAssetsFromParams,
    useNFTMainData,
    useNFTMainOwnerData,
    useReservoirTokensData,
    useUserStats,
} from '@pkg/hooks';

import { type NFTOwnerDataType } from '@app/pages/NFTDetailView/components/OwnerPanel/NFTOwner.data';

interface NFTOwnerModuleDataType {
    data: NFTOwnerDataType | undefined;
    isLoading: boolean;
    isFetching: boolean;
}

export const useNFTOwnerModuleData = (): Partial<NFTOwnerModuleDataType> => {
    const { data: mainData, isLoading: isLoadingMainData, isFetching: isFetchingMainData } = useNFTMainData();
    const {
        data: collectionAssetsData,
        isLoading: isLoadingCollectionAssetsData,
        isFetching: isFetchingCollectionAssetsData,
    } = useNFTCollectionAssetsFromParams();
    const {
        data: mainCollectionData,
        isLoading: isLoadingMainCollectionData,
        isFetching: isFetchingMainCollectionData,
    } = useReservoirTokensData();
    const { data: userStats, isLoading: isLoadingUserStats, isFetching: isFetchingUserStats } = useUserStats();
    const { owner, isLoading: isLoadingOwnerData, isFetching: isFetchingOwnerData } = useNFTMainOwnerData();
    const { primary_yat, id, twitter_handle } = owner || {};

    const rank = mainCollectionData?.tokens?.[0]?.token.rarityRank || 0;

    const bought_at = (collectionAssetsData?.last_sale?.timestamp || 0) * 1000;

    const isFetching =
        isFetchingCollectionAssetsData ||
        isFetchingMainCollectionData ||
        isFetchingMainData ||
        isFetchingOwnerData ||
        isFetchingUserStats;

    const isLoading =
        isLoadingMainCollectionData ||
        isLoadingCollectionAssetsData ||
        isLoadingMainData ||
        isLoadingOwnerData ||
        isLoadingUserStats;

    return {
        data: {
            owner: {
                primary_yat: primary_yat || '',
                user_id: id || '',
                twitter: twitter_handle || '',
                last_activity: userStats?.last_activity || '',
                liquid_id: '',
                owned_nfts: userStats?.owned_nfts || 0,
                wallet_address: '',
            },
            bought_at: bought_at ? new Date(bought_at).toISOString() : '',
            minter: !!mainData?.minter,
            rank,
        },
        isFetching,
        isLoading,
    };
};
